import React from "react";
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import { Dialog, DialogProps, makeStyles, Grid } from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import Typography from "@material-ui/core/Typography";

import { ButtonSubmit } from "components/shared";

import { PageHeader } from "components/shared/PageHeader";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      alignItems: "center",
      margin: 0,
      padding: theme.spacing(3),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

const useStyles = makeStyles({
  infoContainer: {
    border: "1px solid gray",
    borderRadius: "10px",
    padding: 10,
    marginBottom: 10,
  },
  titles: {
    fontSize: "1.7rem",
    width: "160px",
    fontWeight: "bold",
  },
  infos: {
    fontSize: "1.7rem",
    color: "rgb(97, 97, 97)",
  },
  typo: {
    display: "flex",
    marginBottom: 10,
  },
  confirm: {
    fontSize: "1.7rem",
  },
  "@media (max-width: 661px)": {
    infoContainer: {
      width: "100%",
    },
    titles: {
      fontSize: "1.5rem",
    },
    infos: {
      fontSize: "15px",
    },
    typo: {
      display: "flex",
      flexDirection: "column",
    },
    btnsContainer: {
      justifyContent: "flex-start",
    },
  },
});

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {/* {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon fontSize="large" style={{color: 'var(--black)'}}/>
        </IconButton>
      ) : null} */}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    marginTop: "-50px",
    padding: theme.spacing(3),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(3),
  },
}))(MuiDialogActions);

interface DialogDetailsProps extends DialogProps {
  title: string;
  open: boolean;
  setOpen: (value: boolean) => void;
  maxWidth?: false | "md" | "xs" | "sm" | "lg" | "xl" | undefined;
  order: {
    BAIRRO: string;
    CEP: string;
    COMPLEMENTO: string;
    CPF: string;
    DESCRICAO: string;
    DHFIM: string;
    DHINICIO: string;
    DHTRANSACAO: string;
    DSCIDADE: string;
    DSMCM: string;
    DSUF: string;
    END_NUMERO: string;
    IDMCM: number;
    IDTRANSACAO: number;
    IDUSUARIODEST: number;
    IDUSUARIOSOURCE: number;
    LOGRADOURO: string;
    NMUSUARIO: string;
    NUMERO: number;
    STTRANSACAO: number;
    TELEFONE: string;
  };
}

export default function DialogColect({
  title,
  open,
  setOpen,
  maxWidth = "sm",
  order,
}: DialogDetailsProps) {
  const useClasses = useStyles();
  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    // fazer a solicitação de coleta
    try {
      alert("fazer a solicitação de coleta");
    } catch {
      alert("erro ao fazer a solicitação de coleta");
    } finally {
      setOpen(false);
    }
  };

  const formatPhone = (tell: any) => {
    if (!tell) return "-";
    const phone = tell.split("");
    const phoneEdited = `(${phone[2]}${phone[3]}) ${phone[4]}${phone[5]}${phone[6]}${phone[7]}${phone[8]}-${phone[9]}${phone[10]}${phone[11]}${phone[12]}`;
    return phoneEdited;
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      maxWidth={maxWidth}
      fullWidth
    >
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        <PageHeader title="Coletar encomenda" showUserData={false} />
      </DialogTitle>

      <DialogContent>
        <Grid className={useClasses.infoContainer}>
          <Typography
            variant="h5"
            style={{
              marginTop: 8,
            }}
            className={useClasses.typo}
          >
            <div className={useClasses.titles}>Cód. Transação</div>
            <div className={useClasses.infos}>{order?.IDTRANSACAO}</div>
          </Typography>

          <Typography variant="h5" className={useClasses.typo}>
            <div className={useClasses.titles}>Box</div>
            <div className={useClasses.infos}>{order?.NUMERO}</div>
          </Typography>

          <Typography variant="h5" className={useClasses.typo}>
            <div className={useClasses.titles}>Tamanho</div>
            <div className={useClasses.infos}>{order?.DESCRICAO}</div>
          </Typography>
          <Typography variant="h5" className={useClasses.typo}>
            <div className={useClasses.titles}>Destinatário</div>
            <div className={useClasses.infos}>
              {order?.NMUSUARIO} - {formatPhone(order?.TELEFONE)}
            </div>
          </Typography>
        </Grid>
        <Typography className={useClasses.confirm}>
          Confirma a solicitação de coleta?
        </Typography>
      </DialogContent>

      <DialogActions>
        <ButtonSubmit autoFocus onClick={handleClose} color="primary">
          NÃO
        </ButtonSubmit>
        <ButtonSubmit autoFocus onClick={handleConfirm} color="primary">
          SIM
        </ButtonSubmit>
      </DialogActions>
    </Dialog>
  );
}
